import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { Flex } from 'Components/Base';
import Loading from 'Components/Loading';
import { useConfig } from 'Context/ConfigContext';
import { useCapacitor } from 'Util/Capacitors';
import { isTungKaiHandOffEnabled } from 'Util/isTungKaiHandOffEnabled';
import { navigateToTungKai } from 'Util/navigateToTungKai';

import {
  isLoading as isLoadingSelector,
  isLogin as isLoginSelector,
  myProfile as myProfileSelector,
} from '../../Redux/user-profile/selectors';

const CenteredLoading = () => (
  <Flex justifyContent={'center'} alignItems={'center'} height={'100vh'}>
    <Loading />
  </Flex>
);

const Landing = () => {
  const isLoading = useSelector(isLoadingSelector);
  const isLogin = useSelector(isLoginSelector);
  const user = useSelector(myProfileSelector);
  const config = useConfig();
  const { landingRoute = '/my-courses' } = config;
  const { openInApp } = useCapacitor();

  const canGoToTungKai = isLogin && isTungKaiHandOffEnabled(config, user?.id) && !!openInApp;
  const [tungKaiFailed, setTungKaiFailed] = useState(false);

  useEffect(() => {
    if (canGoToTungKai) {
      navigateToTungKai({ config, openInApp }).catch(() => setTungKaiFailed(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canGoToTungKai]);

  if (isLoading) return <CenteredLoading />;
  if (!isLogin) return <Redirect to={'/login'} />;
  if (canGoToTungKai && !tungKaiFailed) return <CenteredLoading />;
  return <Redirect to={landingRoute} />;
};

export default Landing;
